import PropTypes from 'prop-types';
const htmlAttrTypes = {
  dataSet: PropTypes.object,
  id: PropTypes.string,
  loading: PropTypes.oneOf(['eager', 'lazy']),
  // @todo figure out if we need to enum all the possible roles or maybe use
  // an npm package
  role: PropTypes.string,
  src: PropTypes.string,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  testID: PropTypes.string,
  title: PropTypes.string
};
export default {
  types: htmlAttrTypes,
  select: props => Object.entries(props).reduce((items, _ref) => {
    let [key, value] = _ref;
    return Object.keys(htmlAttrTypes).includes(key) || /^(data|aria)-/.test(key) ? {
      ...items,
      [key]: value
    } : items;
  }, {})
};